module.exports = __webpack_public_path__ + "img/at.0d38e4d8.svg";